(function () {
  function initSlider(root) {
    if (root.dataset.mtsInitialized === 'true') return;
    root.dataset.mtsInitialized = 'true';

    var slides = root.querySelectorAll('[data-mts-slide]');
    var dots = root.querySelectorAll('[data-mts-dot]');
    var prevBtn = root.querySelector('[data-mts-prev]');
    var nextBtn = root.querySelector('[data-mts-next]');
    var autoplay = root.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    var current = 0;
    var timer = null;

    if (slides.length < 2) return;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
    }

    function next() {
      show(current + 1);
    }

    function prev() {
      show(current - 1);
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = window.setInterval(next, autoplaySpeed);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.index, 10));
        startAutoplay();
      });
    });

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('.media-text-slider').forEach(initSlider);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.media-text-slider');
    if (root) {
      root.dataset.mtsInitialized = 'false';
      initSlider(root);
    }
  });
})();
